import { queryOptions } from '@tanstack/react-query'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

import { Salutation, User } from '../domain/user'

const client = new Client(getConfig().API_ENDPOINT ?? '')

type UsersSearchResult = User[]

export const getUsers = async (): Promise<User[]> => {
  return await client.get<UsersSearchResult>('/api/shipping/api/v1/users')
}

export const getUser = async (id: string): Promise<User> => {
  const users = await getUsers()
  const user = users.find((user) => user._id === id)

  if (!user) {
    throw new Error(`Could not find user with ID ${id}`)
  }

  return user
}

export type UpdateUserProps = {
  customerId: string
  userId: string
  data: {
    salutation?: Salutation
    title?: string
    firstName: string
    lastName: string
    phoneLandline?: string
    phoneMobile?: string
    roles: string[]
    organizationId: string
  }
}

export const updateUser = async (props: UpdateUserProps): Promise<void> => {
  await client.put(`/api/shipping/api/customers/${props.customerId}/users/${props.userId}`, props.data)
}

export type DeleteUserProps = {
  userId: string
}

export const deleteUser = async (props: DeleteUserProps): Promise<void> => {
  await client.delete(`/api/shipping/api/v1/users/${props.userId}`)
}

export type SendInvitationProps = {
  userId: string
}

export const sendInvitation = async (props: SendInvitationProps): Promise<void> => {
  await client.post(`/api/shipping/api/v1/users/${props.userId}/sendInvitation`)
}

export type CreateUserProps = {
  data: {
    salutation?: Salutation
    title?: string
    firstName: string
    lastName: string
    phoneLandline?: string
    phoneMobile?: string
    email: string
    roles: string[]
    organizationId: string
  }
}

export const createUser = async (props: CreateUserProps): Promise<void> => {
  await client.post('/api/shipping/api/v1/users', props.data)
}

export const usersQueryOptions = () =>
  queryOptions({
    queryKey: ['users'],
    queryFn: getUsers,
  })

export const userQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['users', id],
    queryFn: () => getUser(id),
  })
